export default __webpack_public_path__ + "static/media/background.777af1f4.jpg";